import React from 'react'
import { FormattedMessage } from 'react-intl'
import { PROJECT_ROLE_EDITOR, MULT_PROJECTS_ORGS } from 'utils/constants'
import { get } from 'utils'
import { countOwnProjects } from 'utils/shares'

export async function getLeftMenuData() {
  return [
    {
      title: <FormattedMessage id="menu.overview" />,
      key: 'Overview',
      url: '/overview',
      icon: 'icmn icmn-home',
    },
    {
      divider: true,
    },
    {
      title: <FormattedMessage id="menu.capTable" />,
      key: 'CapTable',
      url: '/cap-table',
      icon: 'icmn icmn-table2',
    },
    {
      title: <FormattedMessage id="menu.securities" />,
      key: 'Securities',
      url: '/securities',
      icon: 'icmn icmn-file-text',
    },
    {
      title: <FormattedMessage id="menu.stakeholders" />,
      key: 'Stakeholders',
      url: '/stakeholders',
      icon: 'icmn icmn-users',
    },
    {
      title: <FormattedMessage id="menu.esop" />,
      key: 'ESOP',
      icon: 'icmn icmn-pie-chart',
      tag: <FormattedMessage id="new" />,
      children: [
        {
          title: <FormattedMessage id="menu.esop.overview" />,
          key: 'ESOP-overview',
          url: '/esop',
          icon: 'icmn icmn-database',
        },
        {
          title: <FormattedMessage id="menu.esop.grantsOverview" />,
          key: 'ESOP-grants-overview',
          url: '/grants-overview',
          icon: 'icmn icmn-address-book',
        },
        {
          title: <FormattedMessage id="menu.esop.grantModelling" />,
          key: 'ESOP-grant-modelling',
          url: '/grant-modelling',
          icon: 'icmn icmn-calculator',
        },
      ],
    },
    {
      title: <FormattedMessage id="menu.vestingSchedules" />,
      key: 'VestingSchedules',
      url: '/vesting',
      icon: 'icmn icmn-calendar',
    },
    {
      divider: true,
    },
    {
      title: <FormattedMessage id="menu.waterfallAnalysis" />,
      key: 'Waterfall Analysis',
      url: '/waterfall-analysis',
      icon: 'icmn icmn-share',
    },
    {
      title: <FormattedMessage id="menu.futureModelling" />,
      key: 'Modelling',
      url: '/modelling',
      icon: 'icmn icmn-stats-dots',
    },
    {
      title: <FormattedMessage id="menu.documents" />,
      key: 'Documents',
      url: '/documents',
      icon: 'icmn icmn-files-empty',
    },
    {
      divider: true,
    },
    {
      title: <FormattedMessage id="menu.editProject" />,
      key: 'Edit',
      url: '/edit',
      icon: 'icmn icmn-pencil',
      restrictVisibility: (user, membership) => {
        return !membership || !PROJECT_ROLE_EDITOR.includes(membership.projectRole)
      },
    },
    {
      title: <FormattedMessage id="menu.addProject" />,
      key: 'NewProject',
      url: '/guide?showWelcome',
      icon: 'icmn icmn-plus',
      restrictVisibility: (user, membership, projects) => {
        const organizationType = get('group.organizationType', user, null)
        const ownProjects = countOwnProjects(projects, user)
        const isNotAdmin = !user || !['ADMIN', 'SUPPORT'].includes(user.userStatus)
        return (
          isNotAdmin &&
          ownProjects > 0 &&
          (!organizationType || !MULT_PROJECTS_ORGS.includes(organizationType))
        )
      },
    },
    {
      title: <FormattedMessage id="menu.adminDashboard" />,
      key: 'AdminDashboard',
      url: '/admin-dashboard',
      icon: 'icmn icmn-user-tie',
      restrictVisibility: (user) => !user || user.userStatus !== 'ADMIN',
    },

    {
      title: <FormattedMessage id="menu.settings" />,
      key: 'settings',
      icon: 'icmn icmn-cog utils__spin-delayed--pseudo-selector',
    },
  ]
}
export async function getTopMenuData() {
  return [
    {
      title: <FormattedMessage id="menu.overview" />,
      key: 'Overview',
      url: '/overview',
      icon: 'icmn icmn-home',
    },
    {
      title: <FormattedMessage id="menu.futureModelling" />,
      key: 'Modelling',
      url: '/modelling',
      icon: 'icmn icmn-stats-dots',
      tag: <FormattedMessage id="general.beta" />,
    },
    /*
    {
      title: <FormattedMessage id='menu.editProject' />,
      key: 'Edit',
      url: '/edit',
      icon: 'icmn icmn-pencil',
      projectRoles: ['OWNER', 'ADMIN', 'EDITOR'],
    },
    {
      title: <FormattedMessage id='menu.addProject' />,
      key: 'NewProject',
      url: '/guide',
      icon: 'icmn icmn-plus',
    },
    */
    {
      title: <FormattedMessage id="menu.settings" />,
      key: 'settings',
      icon: 'icmn icmn-cog utils__spin-delayed--pseudo-selector',
    },
  ]
}
